import type { PartDefinition, MaterialValue } from "@rogue/rackbuilder"
import { resolveColorMaterial } from "../../constants"
import { ADJ_BENCH_3, MANTA, UTILITY_BENCH, ADJ_BENCH_4 } from "../../modelPaths"
import type { IRogue, BuyRequest, Product } from "@/js/services/RogueTypes"
import { getBuyRequestMeta } from "@/js/helpers/buy-request"

export class BenchBuilder {
  constructor(private rogue: IRogue, private buyRequest: BuyRequest) {}

  public buildAdjBench(): PartDefinition {
    const meta = getBuyRequestMeta(this.buyRequest, this.rogue)
    const bench = this.rogue.getProductById(meta.id)

    return {
      mesh      : ADJ_BENCH_3,
      slots     : {},
      materials : {
        mg      : resolveColorMaterial(bench.attributes.color || 'Satin Black'),
        edition : { material: bench.attributes.edition === 'Stainless Steel' ? 'stainless' : 'mg' },
      },
    }
  }

  public buildManta(): PartDefinition {
    const meta = getBuyRequestMeta(this.buyRequest, this.rogue)

    const bench = this.rogue.getProductById(meta.id)

    const baseMaterial: MaterialValue = resolveColorMaterial(bench.attributes.color || 'Satin Black')

    const materials: PartDefinition['materials'] = {
      main: baseMaterial,
    }

    if (bench.attributes.color === 'Textured Black') {
      baseMaterial.material = 'matte'
      baseMaterial.color = '#222222'
      // Textured Black gets a black handle
      materials.handle = { name: 'rogue', material: 'plastic' }
    }

    return {
      mesh  : `${MANTA}#bench`,
      slots : bench.attributes.rig_or_wm === 'No' ? {} : {
        footcatch: { mesh: `${MANTA}#footcatch`, slots: {} },
      },
      materials,
    }
  }

  public static getBenchPart(product?: Product): PartDefinition | undefined {
    if (!product) {
      return undefined
    }
    const name = product.name.toLowerCase()

    if (name.includes('utility')) {
      return { mesh: UTILITY_BENCH, slots: {} }
    }

    return undefined
  }

  public buildAdjustableBenchFour(): PartDefinition {
    const meta = getBuyRequestMeta(this.buyRequest, this.rogue)
    const bench = this.rogue.getProductById(meta.id)
    
    const baseMaterial: MaterialValue = resolveColorMaterial(bench.attributes.color || 'Satin Black')
    const materials: PartDefinition['materials'] = { main: baseMaterial }

    const hasFootCatch = bench.attributes?.rig_or_wm === 'Foot Catch'
    const isStainlessSteel = bench.attributes.edition === 'Stainless Steel'

    if (isStainlessSteel) {
      materials.handle = { material: 'chrome' }
    }

    return {
      mesh  : `${ADJ_BENCH_4}#bench`,
      slots : hasFootCatch 
        ? { footcatch: { mesh: `${ADJ_BENCH_4}#footcatch`, slots: {} } }
        : {},
      materials,
    }
  }


}
